export const isShowMoreWithHeight = $wrap => $wrap.is('[data-show-more="with-height"]');
export const setMaxHeight = ($el, height) => $el.css('--show-more-height', `${height}px`);
export const removeHeight = ($btn, text) => $btn.removeClass('active').find('> span').text(text);
export const addHeight = ($btn, text) => $btn.addClass('active').find('> span').text(text);
